import { render, staticRenderFns } from "./VegiView.vue?vue&type=template&id=c8f862fe&"
import script from "./VegiView.vue?vue&type=script&lang=js&"
export * from "./VegiView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports